import { render, staticRenderFns } from "./QuizApp.vue?vue&type=template&id=63aae20c"
import script from "./QuizApp.vue?vue&type=script&lang=js"
export * from "./QuizApp.vue?vue&type=script&lang=js"
import style0 from "./QuizApp.vue?vue&type=style&index=0&id=63aae20c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports